<template>
    <v-card v-bind="$attrs" flat rounded="0">
        <slot />
        <v-divider />
    </v-card>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
